export default __webpack_public_path__ + "static/media/germany.58ea76b1.svg";